import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'material-ui/Checkbox';
import getTheme from '../MuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

var LLCheckbox = /*#__PURE__*/function (_Component) {
  _inherits(LLCheckbox, _Component);

  var _super = _createSuper(LLCheckbox);

  function LLCheckbox() {
    var _this;

    _classCallCheck(this, LLCheckbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "checkboxChecked", function (event, isChecked) {
      if (_this.props.onChange) {
        _this.props.onChange(isChecked);
      }
    });

    return _this;
  }

  _createClass(LLCheckbox, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Checkbox, _extends({}, this.props, {
        label: this.props.label,
        style: _objectSpread(_objectSpread({}, this.props.style), {}, {
          textAlign: 'left'
        }),
        onCheck: this.checkboxChecked,
        disabled: this.props.disabled
      }));
    }
  }]);

  return LLCheckbox;
}(Component);

_defineProperty(LLCheckbox, "propTypes", {
  label: PropTypes.node,
  style: PropTypes.object,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
});

_defineProperty(LLCheckbox, "defaultProps", {
  label: '',
  style: {},
  value: '',
  onChange: function onChange() {},
  disabled: false,
  checked: false
});

export { LLCheckbox as default };